<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import Swal from '@/utils/ugm-swal';
import Multiselect from 'vue-multiselect';

export default {
    components: { Layout, PageHeader, Multiselect },
    data() {
        return {
            title: "Usuarios",
            items: [
                {
                text: "Usuarios",
                href: "/web/configuracion/usuarios"
                },
            ],
            usuarios:[],
            datos_editar:{
                tipo:'',
                rut:'',
                nombre:'',
                correo:'',
                telefono:'',
            },
            habilitar_boton: false,
            editing: false,
            originalUser:'',
            emailError:'',
            phoneerror:'',
            ruterror:'',
            cargos:['Coordinador Vigente','Coordinador de reemplazo','Supervisor','Director'],
            busqueda: '',
            syncingOwner: null,
            bloqueos: {},
            savingBlock: null,
            blocksLoaded: false
        };
    },
    computed: {
        canManageAccessBlocks() {
            return this.user && this.user.rol === 'SuperAdmin';
        },
        filteredUsuarios() {
            const q = this.busqueda.toLowerCase().trim();
            if (!q) return this.usuarios;
            return this.usuarios.filter(u =>
                (u.name || '').toLowerCase().includes(q) ||
                (u.rut || '').toLowerCase().includes(q)
            );
        }
    },
    mounted() {
    },
    methods: {
        async loadAccessBlocks() {
            try {
                const res = await axios.get('/api/usuarios/bloqueos');
                res.data.bloqueos.forEach(block => this.$set(this.bloqueos, block.id, block));
                this.blocksLoaded = true;
            } catch (error) {
                this.msg('error', 'No se pudieron cargar los bloqueos de acceso.');
            }
        },
        async saveAccessBlock(usuario, clear = false) {
            if (clear) {
                const result = await Swal.fire({
                    title: '¿Eliminar el bloqueo de acceso?',
                    text: 'Se eliminará el rango de fechas configurado para este usuario.',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Eliminar bloqueo',
                    cancelButtonText: 'Cancelar'
                });
                if (!result.isConfirmed) return;
            }
            this.savingBlock = usuario.id;
            const block = this.bloqueos[usuario.id];
            try {
                const res = await axios.put(`/api/usuarios/${usuario.id}/bloqueo`, {
                    desde: clear ? null : block.desde || null,
                    hasta: clear ? null : block.hasta || null
                });
                this.$set(this.bloqueos, usuario.id, res.data.bloqueo);
                this.msg('success', res.data.mensaje);
            } catch (error) {
                const data = error.response && error.response.data;
                const errors = data && data.errors ? Object.values(data.errors).flat() : [];
                this.msg('error', errors[0] || (data && data.mensaje) || 'No se pudo guardar el bloqueo.');
            } finally {
                this.savingBlock = null;
            }
        },
        syncHubspotOwner(usuario) {
            this.syncingOwner = usuario.id;
            axios.post('/api/sync_hubspot_owner', { id: usuario.id })
                .then(res => {
                    if (res.data.estado) {
                        usuario.hubspot_owner_id = res.data.hubspot_owner_id;
                        this.msg('success', res.data.mensaje);
                    } else {
                        this.msg('warning', res.data.mensaje);
                    }
                })
                .catch(() => this.msg('error', 'Error al conectar con HubSpot.'))
                .finally(() => { this.syncingOwner = null; });
        },
        msg(tipo, titulo){
            Swal.fire({
                icon: tipo,
                title: `<span style="color:#252C5F;font-weight:700;">${titulo}</span>`,
                confirmButtonText: 'Aceptar',
                confirmButtonColor: '#252C5F',
                background: '#fff',
                showConfirmButton: tipo !== 'success',
                timer: tipo === 'success' ? 2500 : undefined,
                customClass: { popup: 'rounded-lg' }
            });
        },
        toggleEdit(usuario) {
            this.originalUser = { ...usuario };
            if (this.editing) {
                this.isLoading=true
                axios.post('/api/editar_usuario',this.datos_editar).then(res=>{
                    if(res.data.estado){
                        this.usuarios=res.data.usuarios;
                        this.msg(res.data.color,res.data.mensaje);
                        //window.location.reload();
                    }else{
                        this.msg(res.data.color,res.data.mensaje);
                    }
                    this.isLoading=false
                })
            }else{
                this.datos_editar.id=usuario.id;
                this.datos_editar.name=usuario.name;
                this.datos_editar.rut=usuario.rut;
                this.datos_editar.email=usuario.email;
                this.datos_editar.cargo=usuario.cargo;
                this.datos_editar.telefono=usuario.telefono;
            }
            this.editing = !this.editing;
        },
        cancelEdit() {
            // Restaurar los valores originales si se cancela la edición
            //this.sucursal = { ...this.originalSucursal };
            this.editing = false;
        },
        ver_mas(usuario){
            this.editing = false;
            if (usuario.boton=='Ver más') {
                usuario.boton='Ver menos'
            }else if(usuario.boton=='Ver menos'){
                usuario.boton='Ver más'
            }
        },
        formatRut() {
            // Eliminamos todos los caracteres que no sean números o 'k'
            let cleanRut = this.datos_editar.rut.replace(/[^0-9kK]/g, "").toUpperCase();
            if (cleanRut.length > 10) {
                cleanRut = cleanRut.slice(0, 10); // Limitar a 9 dígitos + DV
            }
            // Si el RUT tiene más de un carácter, separamos el dígito verificador
            if (cleanRut.length > 1) {
                const body = cleanRut.slice(0, -1); // Todo menos el último carácter
                const dv = cleanRut.slice(-1); // Último carácter como dígito verificador
                // Agregamos los puntos cada tres dígitos al cuerpo
                const formattedBody = body.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                // Concatenamos el cuerpo formateado con el dígito verificador
                this.datos.rut = `${formattedBody}-${dv}`;
            } else {
                // Si el RUT tiene un solo carácter, lo dejamos tal cual
                this.datos_editar.rut = cleanRut;
            }
        },
        cleanRut(value) {
            return value.replace(/^0+|[^0-9kK]+/g, '').toUpperCase();
        },
        validateRut() {
            let rut = this.cleanRut(this.datos_editar.rut);
            let digito_verificador = this.datos_editar.rut.substr(-1);
            rut = rut.substr(0, rut.length - 1);
            let serie = 0;
            let producto = 0;
            do {
                producto += (rut % 10) * ((serie % 6) + 2);
                serie++;
            } while (rut = Math.floor(rut / 10));
            let resto = producto % 11;
            let resultado = 11 - resto;
            if (resultado == 11) {
                resultado = 0;
            } else if (resultado == 10) {
                resultado = 'K';
            }
            if (digito_verificador != resultado || digito_verificador=='') {
                this.ruterror = 'RUT inválido';
            } else {
                this.ruterror = '';
            }
        },
        validateEmail() {
            if (this.datos_editar.email && !this.isEmailValid) {
                this.emailError = 'El correo electrónico no es válido.';
            } else {
                this.emailError = '';
            }
        },
        formatPhoneNumber() {
            // Elimina todo lo que no sea número
            let digits = this.datos_editar.telefono.replace(/\D/g, "");
            // Agrega el prefijo "+56" si no está presente
            if (!digits.startsWith("56")) {
                digits = "56" + digits;
            }
            // Limita a un máximo de 11 caracteres (+56 + 9 dígitos)
            if (digits.length > 11) {
                digits = digits.slice(0, 11);
            }
            // Actualiza el input con el formato correcto
            this.datos_editar.telefono = "+" + digits;
        },
        validatePhoneNumber() {
            // Validar que el número tenga exactamente 11 caracteres (+56 + 9 dígitos)
            if (this.datos_editar.telefono.length !== 12) {
                this.phoneerror = "El número debe ser +56 seguido de 9 dígitos.";
            } else {
                this.phoneerror = "";
                //alert("Número válido: " + this.datos.telefono);
                // Aquí puedes continuar con el envío del formulario
            }
        },
        restrictToNumbers(event) {
            const allowedKeys = [
                "Backspace",
                "Tab",
                "ArrowLeft",
                "ArrowRight",
                "Delete",
            ];
            // Permitir teclas especiales y números
            if (
                !allowedKeys.includes(event.key) &&
                !/^\d$/.test(event.key) // Permitir solo números
            ) {
                event.preventDefault();
            }
        },
        restrictInput(event) {
            // Permitir solo letras y teclas de control (Backspace, Delete, etc.)
            const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'];
            const isLetter = /^[a-zA-Z]$/.test(event.key);
            if (!isLetter && !allowedKeys.includes(event.key)) {
                event.preventDefault(); // Previene la entrada de caracteres no permitidos
            }
        },
        restrictInput_withspace(event) {
            // Permitir solo letras, espacios y teclas de control (Backspace, Delete, etc.)
            const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'];
            const isLetterOrSpace = /^[a-zA-Z\s]$/.test(event.key);

            if (!isLetterOrSpace && !allowedKeys.includes(event.key)) {
                event.preventDefault(); // Previene la entrada de caracteres no permitidos
            }
        },
        eliminar(usuario){
            let formData = new FormData();
            formData.append('usuario_id', usuario.id);
            axios.post('/api/eliminar_usuario',formData).then(res=>{
                if(res.data.estado){
                    this.usuarios=res.data.usuarios;
                    this.msg(res.data.color,res.data.mensaje);
                }else{
                    this.msg(res.data.color,res.data.mensaje);
                }
            })
        }
    },
    created(){
        if (this.canManageAccessBlocks) this.loadAccessBlocks();
        axios.get('/api/get_usuarios').then(res=>{
            this.usuarios=res.data.usuarios;
        });
    }
};
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />

        <div class="row">
            <div class="col-12">
                <div class="card">

                    <!-- Header -->
                    <div class="card-header py-3 d-flex align-items-center"
                        style="background: linear-gradient(135deg, #252C5F 0%, #61B7E4 100%); border-radius: 4px 4px 0 0;">
                        <i class="bx bx-group font-size-24 text-white mr-2"></i>
                        <div>
                            <h5 class="text-white mb-0 font-weight-bold">Gestión de Usuarios</h5>
                            <small class="text-white" style="opacity:.8;">Administra los usuarios de la plataforma</small>
                        </div>
                    </div>

                    <div class="card-body pt-4">

                        <!-- Barra de búsqueda + botón -->
                        <div class="row mb-4 align-items-center">
                            <div class="col-md-6">
                                <b-input-group>
                                    <b-input-group-prepend is-text>
                                        <i class="bx bx-search-alt" style="color:#252C5F;"></i>
                                    </b-input-group-prepend>
                                    <b-form-input v-model="busqueda" placeholder="Buscar por nombre o RUT..." />
                                </b-input-group>
                            </div>
                            <div class="col-md-6 text-right">
                                <a href="/web/configuracion/crearusuario"
                                    class="btn btn-lg"
                                    style="background:#252C5F;color:#fff;border-color:#252C5F;">
                                    <i class="bx bx-user-plus mr-1"></i> Agregar Usuario
                                </a>
                            </div>
                        </div>

                        <!-- Tabla principal -->
                        <div class="table-responsive">
                            <table class="table table-hover mb-0">
                                <thead>
                                    <tr style="background:#f4f6fb;">
                                        <th style="width:40px;color:#252C5F;">#</th>
                                        <th style="color:#252C5F;">Nombre</th>
                                        <th style="color:#252C5F;width:150px;">RUT</th>
                                        <th style="color:#252C5F;width:140px;">Rol</th>
                                        <th style="color:#252C5F;text-align:right;width:120px;">Detalle</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-if="filteredUsuarios.length === 0">
                                        <td colspan="6" class="text-center text-muted py-4">
                                            <i class="bx bx-user-x font-size-24 d-block mb-1"></i>
                                            No se encontraron usuarios.
                                        </td>
                                    </tr>
                                    <template v-for="(usuario, index) in filteredUsuarios">
                                        <tr :key="'row-' + usuario.id">
                                            <td class="align-middle text-muted small">{{ index + 1 }}</td>
                                            <td class="align-middle font-weight-medium">
                                                <i class="bx bx-user-circle mr-1" style="color:#61B7E4;font-size:1.1rem;"></i>
                                                {{ usuario.name }}
                                                <span v-if="canManageAccessBlocks && blocksLoaded && bloqueos[usuario.id] && bloqueos[usuario.id].bloqueado"
                                                    class="badge badge-danger ml-2"
                                                    title="Bloqueo de acceso vigente según las fechas guardadas (horario de Chile)">
                                                    <i class="bx bx-lock-alt mr-1" aria-hidden="true"></i>Bloqueado
                                                </span>
                                            </td>
                                            <td class="align-middle text-muted">{{ usuario.rut || '—' }}</td>
                                            <td class="align-middle">
                                                <span class="badge px-2 py-1"
                                                    :style="usuario.rol === 'Administrador'
                                                        ? 'background:#252C5F;color:#fff;'
                                                        : usuario.rol === 'Coordinador'
                                                            ? 'background:#CB9700;color:#fff;'
                                                            : 'background:#61B7E4;color:#fff;'">
                                                    {{ usuario.rol }}
                                                </span>
                                            </td>
                                            <td class="align-middle text-right">
                                                <b-button size="sm" variant="outline-secondary"
                                                    v-b-toggle="'usuario-' + usuario.id"
                                                    @click="ver_mas(usuario)">
                                                    <i :class="usuario.boton === 'Ver menos' ? 'bx bx-chevron-up' : 'bx bx-chevron-down'"></i>
                                                    {{ usuario.boton || 'Ver más' }}
                                                </b-button>
                                            </td>
                                        </tr>

                                        <!-- Fila expandible -->
                                        <tr :key="'collapse-' + usuario.id">
                                            <td colspan="6" class="p-0 border-0">
                                                <b-collapse :id="'usuario-' + usuario.id">
                                                    <div class="p-3" style="background:#f8f9fc;border-left:4px solid #252C5F;">

                                                        <!-- Vista detalle -->
                                                        <div v-if="!editing" class="row">
                                                            <div class="col-md-6">
                                                                <div class="d-flex align-items-center mb-3">
                                                                    <div style="width:4px;height:18px;background:#252C5F;border-radius:2px;" class="mr-2"></div>
                                                                    <h6 class="mb-0 font-weight-bold" style="color:#252C5F;">{{ usuario.name }}</h6>
                                                                </div>
                                                                <p class="mb-1 small"><strong>Correo:</strong> {{ usuario.email }}</p>
                                                                <p class="mb-1 small"><strong>Teléfono:</strong> {{ usuario.telefono || '—' }}</p>
                                                                <p class="mb-1 small"><strong>Eventos responsable:</strong> {{ usuario.eventos_propietario || 0 }}</p>
                                                                <p class="mb-1 small"><strong>Eventos coordinador:</strong> {{ usuario.eventos_coordinador || 0 }}</p>
                                                            </div>
                                                            <div class="col-md-6">
                                                                <p class="mb-1 small"><strong>RUT:</strong> {{ usuario.rut || '—' }}</p>
                                                                <p class="mb-1 small"><strong>Cargo:</strong> {{ usuario.cargo || '—' }}</p>
                                                                <p class="mb-1 small">
                                                                    <strong>HubSpot ID:</strong>
                                                                    <span v-if="usuario.hubspot_owner_id" class="badge badge-pill badge-success ml-1">{{ usuario.hubspot_owner_id }}</span>
                                                                    <span v-else class="badge badge-pill badge-danger ml-1">No encontrado</span>
                                                                    <b-button
                                                                        size="sm"
                                                                        class="ml-2 d-inline-flex align-items-center"
                                                                        style="background:#252C5F;border-color:#252C5F;color:#fff;font-size:11px;"
                                                                        :disabled="syncingOwner === usuario.id"
                                                                        @click="syncHubspotOwner(usuario)">
                                                                        <i :class="syncingOwner === usuario.id ? 'bx bx-loader bx-spin mr-1' : 'bx bx-refresh mr-1'"></i>
                                                                        {{ syncingOwner === usuario.id ? 'Buscando...' : 'Buscar ID' }}
                                                                    </b-button>
                                                                </p>
                                                            </div>
                                                            <div v-if="canManageAccessBlocks" class="col-12 mt-3">
                                                                <h6 class="font-weight-bold">Bloqueo temporal de acceso</h6>
                                                                <p class="small text-muted">
                                                                    Ambas fechas incluidas, horario de Chile. El acceso se restablece al día siguiente del término.
                                                                    No se eliminan datos ni se modifica el correo.
                                                                </p>
                                                                <b-button v-if="!blocksLoaded" size="sm" variant="outline-secondary" @click="loadAccessBlocks">
                                                                    Reintentar cargar bloqueos
                                                                </b-button>
                                                                <template v-if="blocksLoaded && bloqueos[usuario.id]">
                                                                    <p class="small">
                                                                        Estado guardado:
                                                                        <strong>{{ bloqueos[usuario.id].bloqueado ? 'Bloqueado' : 'Sin bloqueo vigente' }}</strong>
                                                                    </p>
                                                                    <p v-if="usuario.id === user.id" class="small text-muted">No puedes bloquear tu propio acceso.</p>
                                                                    <div v-else class="row align-items-end">
                                                                        <b-form-group class="col-md-4" label="Desde">
                                                                            <b-form-input type="date" v-model="bloqueos[usuario.id].desde" :disabled="savingBlock !== null" />
                                                                        </b-form-group>
                                                                        <b-form-group class="col-md-4" label="Hasta (inclusive)">
                                                                            <b-form-input type="date" v-model="bloqueos[usuario.id].hasta" :min="bloqueos[usuario.id].desde || undefined" :disabled="savingBlock !== null" />
                                                                        </b-form-group>
                                                                        <div class="col-md-4 mb-3">
                                                                            <b-button size="sm" variant="primary" :disabled="savingBlock !== null || !bloqueos[usuario.id].desde || !bloqueos[usuario.id].hasta" @click="saveAccessBlock(usuario)">
                                                                                Guardar bloqueo
                                                                            </b-button>
                                                                            <b-button size="sm" variant="outline-danger" :disabled="savingBlock !== null" @click="saveAccessBlock(usuario, true)">
                                                                                Eliminar bloqueo
                                                                            </b-button>
                                                                        </div>
                                                                    </div>
                                                                </template>
                                                            </div>
                                                            <div class="col-12 mt-3 d-flex justify-content-end" style="gap:8px;">
                                                                <b-button size="sm" @click="toggleEdit(usuario)"
                                                                    style="background:#252C5F;border-color:#252C5F;color:#fff;">
                                                                    <i class="bx bx-edit mr-1"></i> Editar
                                                                </b-button>
                                                                <b-button size="sm" variant="danger" @click="eliminar(usuario)">
                                                                    <i class="bx bx-trash mr-1"></i> Eliminar
                                                                </b-button>
                                                            </div>
                                                        </div>

                                                        <!-- Vista edición -->
                                                        <div v-if="editing && datos_editar.id === usuario.id">
                                                            <div class="d-flex align-items-center mb-3">
                                                                <div style="width:4px;height:18px;background:#CB9700;border-radius:2px;" class="mr-2"></div>
                                                                <h6 class="mb-0 font-weight-bold" style="color:#252C5F;">Editando: {{ usuario.name }}</h6>
                                                            </div>
                                                            <div class="row">
                                                                <div class="col-md-6">
                                                                    <b-form-group label="Nombre" label-class="font-weight-medium small">
                                                                        <b-form-input v-model="datos_editar.name" @keydown="restrictInput_withspace" />
                                                                    </b-form-group>
                                                                    <b-form-group label="Correo Electrónico" label-class="font-weight-medium small">
                                                                        <b-form-input type="email" v-model="datos_editar.email" @blur="validateEmail" />
                                                                        <small class="text-danger" v-if="emailError">{{ emailError }}</small>
                                                                    </b-form-group>
                                                                </div>
                                                                <div class="col-md-6">
                                                                    <b-form-group label="RUT" label-class="font-weight-medium small">
                                                                        <b-form-input v-model="datos_editar.rut" @blur="validateRut" @input="formatRut" maxlength="12" />
                                                                        <small class="text-danger" v-if="ruterror">{{ ruterror }}</small>
                                                                    </b-form-group>
                                                                    <b-form-group label="Tipo de Usuario" label-class="font-weight-medium small">
                                                                        <multiselect v-model="datos_editar.cargo"
                                                                            :options="cargos"
                                                                            placeholder="Seleccionar opción"
                                                                            selectLabel="Presiona para seleccionar"
                                                                            selectedLabel="Seleccionado"
                                                                            deselectLabel="Presiona para remover">
                                                                            <template v-slot:noOptions><p>No hay opciones</p></template>
                                                                            <template v-slot:noResult><p>No se encuentra coincidencia</p></template>
                                                                        </multiselect>
                                                                    </b-form-group>
                                                                    <b-form-group label="Teléfono" label-class="font-weight-medium small">
                                                                        <b-form-input v-model="datos_editar.telefono"
                                                                            @input="formatPhoneNumber"
                                                                            @blur="validatePhoneNumber"
                                                                            @keydown="restrictToNumbers"
                                                                            maxlength="12" />
                                                                        <small class="text-danger" v-if="phoneerror">{{ phoneerror }}</small>
                                                                    </b-form-group>
                                                                </div>
                                                            </div>
                                                            <div class="d-flex justify-content-end mt-2" style="gap:8px;">
                                                                <b-button size="sm" variant="secondary" @click="cancelEdit">
                                                                    <i class="bx bx-x mr-1"></i> Cancelar
                                                                </b-button>
                                                                <b-button size="sm" @click="toggleEdit(usuario)"
                                                                    style="background:#252C5F;border-color:#252C5F;color:#fff;">
                                                                    <i class="bx bx-save mr-1"></i> Guardar cambios
                                                                </b-button>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </b-collapse>
                                            </td>
                                        </tr>
                                    </template>
                                </tbody>
                            </table>
                        </div>

                        <!-- Contador -->
                        <div class="mt-3 text-right">
                            <small class="text-muted">{{ filteredUsuarios.length }} usuario{{ filteredUsuarios.length !== 1 ? 's' : '' }} encontrado{{ filteredUsuarios.length !== 1 ? 's' : '' }}</small>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>
